// extracted by mini-css-extract-plugin
module.exports = {"tableSortHeaderCell":"E-JpR"};